module.exports = __webpack_public_path__ + "static/images/alert-black.f65d329da8f5fc74a1ece37d91c6aff1.svg";